import { useSearchParams } from 'next/navigation'
import { PRODUCT_LIST_QUERY_PARAMS } from '../../constants/queryParams'
import type { View } from '../../types/View'
import { isView } from '../../utils/isView'

export const useViewSearchParam = (): View | null => {
	const searchParams = useSearchParams()
	const qpView = searchParams.get(PRODUCT_LIST_QUERY_PARAMS.view)
	return isView(qpView) ? qpView : null
}
